import Button from '@amzn/meridian/button';
import React from 'react';
import Row from '@amzn/meridian/row';
import { type AssetStatus, ASSET_STATUSES } from 'src/components/assets/asset-status';
import { useTranslation } from 'src/arb-wrapper';

export type AssetActionType = 'Approve' | 'Reject' | 'Pending' | 'Process';

type AssetStatusActionMap = {
  [key in AssetStatus]: AssetActionType[];
};

type AssetConfigurationMap = {
  [key in AssetActionType]: {
    buttonText: string;
    status: AssetStatus;
  };
};

const approvalStatusActionMap: AssetStatusActionMap = {
  APPROVED: ['Reject', 'Pending'],
  PENDING: ['Process'],
  REJECTED: ['Approve', 'Pending'],
};

export interface AssetActionButtonProps {
  disabled: boolean;
  approvalStatus: AssetStatus;
  onActionClick: (action: AssetStatus) => void;
}

export const AssetActionButton = (props: AssetActionButtonProps) => {
  const { approvalStatus, onActionClick } = props;
  const actions = approvalStatusActionMap[approvalStatus];
  const { t } = useTranslation();

  const actionConfigurationMap: AssetConfigurationMap = {
    Approve: {
      buttonText: t('asset_action_approve'),
      status: ASSET_STATUSES.APPROVED,
    },
    Reject: {
      buttonText: t('asset_action_reject'),
      status: ASSET_STATUSES.REJECTED,
    },
    Pending: {
      buttonText: t('asset_action_pending'),
      status: ASSET_STATUSES.PENDING,
    },
    Process: {
      buttonText: t('asset_action_process'),
      status: ASSET_STATUSES.APPROVED,
    },
  };

  return (
    <Row spacing="300">
      {actions?.map((action) => {
        const { status, buttonText } = actionConfigurationMap[action];
        return (
          <Button
            data-testid={`asset-action-button-${status.toLowerCase()}`}
            disabled={props.disabled}
            key={action}
            type="primary"
            onClick={() => {
              onActionClick(status);
            }}
          >
            {buttonText}
          </Button>
        );
      })}
    </Row>
  );
};
